import { render, staticRenderFns } from "./SkeletonParagraph.vue?vue&type=template&id=663c7669"
import script from "./SkeletonParagraph.vue?vue&type=script&lang=js"
export * from "./SkeletonParagraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports